import { useMemo } from "react";

import { useSearch } from "@tanstack/react-router";

import { PatientList, PatientListByCategory } from "@/models/PatientSummaryModel.ts";

export const useSearchPatientsList = (data: PatientListByCategory): PatientListByCategory => {
  const searchParams = useSearch({
    from: "/_practitioner/patients/",
  });
  const searchTerm = searchParams.search ?? "";

  return useMemo(
    () => ({
      monitored: basicSearch(searchTerm, data.monitored),
      pregnant: basicSearch(searchTerm, data.pregnant),
      all: basicSearch(searchTerm, data.all),
    }),
    [searchTerm, data],
  );
};

/**
 * Basic filter by search term.
 * Search by patient name, diabetes type and tags.
 */
const basicSearch = (search: string, patients: PatientList): PatientList => {
  if (!search) {
    return patients;
  }
  return patients.filter(patient =>
    [
      patient.familyName.toLowerCase(),
      patient.givenName.toLowerCase(),
      patient.familyName.toLowerCase(),
      patient.diabetesType?.toLowerCase(),
      patient.tags.join(" ").toLowerCase(),
    ]
      .join(" ")
      .includes(search.toLowerCase()),
  );
};
